import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_N_ACCOUNT = '/spe-n-accounts';
let SpeNAccountProxy = class SpeNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getUserBankInfo(uuid) {
        const uri = `${SPE_N_ACCOUNT}/v1/user-bank-info/${uuid}`;
        return this.api.get(uri);
    }
    acceptMigration() {
        const uri = `${SPE_N_ACCOUNT}/v1/migration/confirm`;
        // return this.api.post(uri, {}, null, [{name: 'X-Forwarded-For', value: '127.0.0.1'}]);
        return this.api.put(uri, {});
    }
};
SpeNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountProxy);

const SPE_N_ACCOUNTS = '/spe-n-accounts';
let SpeNAccountsProxy = class SpeNAccountsProxy {
    constructor(api) {
        this.api = api;
    }
    newValueUrl(uuidAccountPayment) {
        const uri = `${SPE_N_ACCOUNTS}/v1/new-value/token/`;
        return this.api.post(uri, {}, uuidAccountPayment);
    }
};
SpeNAccountsProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNAccountsProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCheckMigration() {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-payment/verify/migrated/`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNAccountProxy);

const SPE_VIEW_N_MENU = '/spe-view-n-menu';
let SpeViewNMenuProxy = class SpeViewNMenuProxy {
    constructor(api) {
        this.api = api;
    }
    getAllShortcuts(uuidWhiteLabel, uuidAccountPayment, platform) {
        const uri = `${SPE_VIEW_N_MENU}/v1/build-menu-dash/WL/${uuidWhiteLabel}/AP/${uuidAccountPayment}/menu-type/${platform}`;
        return this.api.get(uri);
    }
};
SpeViewNMenuProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNMenuProxy);

let UiPxDashboardModule = class UiPxDashboardModule {
};
UiPxDashboardModule = __decorate([
    NgModule({
        declarations: [],
        imports: [UiBsOauthModule],
        providers: [
            SpeNAccountProxy,
            SpeNAccountsProxy,
            SpeViewNMenuProxy,
            ConfigService,
            SpeViewNAccountProxy
        ],
    })
], UiPxDashboardModule);

class CheckMigrationResponseDto {
}
var StatusStepMigrationEnum;
(function (StatusStepMigrationEnum) {
    StatusStepMigrationEnum["ITAU_OPENED"] = "ITAU_OPENED";
    StatusStepMigrationEnum["ACCEPTED"] = "ACCEPTED";
    StatusStepMigrationEnum["LIMIT"] = "LIMIT";
    StatusStepMigrationEnum["BASKET"] = "BASKET";
    StatusStepMigrationEnum["SCHEDULED"] = "SCHEDULED";
    StatusStepMigrationEnum["FAVORITE"] = "FAVORITE";
    StatusStepMigrationEnum["CARD"] = "CARD";
    StatusStepMigrationEnum["ROLE_USERS"] = "ROLE_USERS";
    StatusStepMigrationEnum["BALANCE"] = "BALANCE";
    StatusStepMigrationEnum["ROLE"] = "ROLE";
    StatusStepMigrationEnum["ACCOUNT_CANCELED"] = "ACCOUNT_CANCELED";
    StatusStepMigrationEnum["FINISHED"] = "FINISHED";
})(StatusStepMigrationEnum || (StatusStepMigrationEnum = {}));
class ContractMigrationDto {
}
class MigrationResponse {
}

class NewValueDTO {
}

export { CheckMigrationResponseDto, ConfigService, ContractMigrationDto, MigrationResponse, NewValueDTO, SpeNAccountProxy, SpeNAccountsProxy, SpeViewNAccountProxy, SpeViewNMenuProxy, StatusStepMigrationEnum, UiPxDashboardModule };
//# sourceMappingURL=wlp-ui-px-dashboard.js.map
